import { h } from "preact";
import Waitlist from "../../../components/waitlist/Waitlist";
const format = require("../../../utils/Format");
import { css, keyframes } from "emotion";
import { determineManualOrder } from "../../../utils/ManualOrderUtils";
const feesStr = css({
  color: "#5A626C",
  fontSize: 11,
  fontWeight: "normal",
  display: "block"
});

const accessGrantedAnimation = keyframes({
  "0%": {
    backgroundColor: "#e8fcf5",
    color: "#157e77"
  },
  "40%": {
    backgroundColor: "#e8fcf5",
    color: "#157e77"
  },
  "60%": {
    backgroundColor: "#e8fcf5",
    color: "#157e77"
  },
  "100%": {
    backgroundColor: "#fff",
    color: "#323232"
  }
});

const ticketPriceStyle = css({
  width: 180,
  marginLeft: 8,
  alignItems: "center",
  display: "flex",
  "@media(max-width: 600px)": {
    marginTop: 8
  }
});

const TicketsSelect = ({ ticket, addQuantity, addPrice, ticketGroupIndex }) => {
  var options = [];
  options.push(<option>0</option>);
  const minTickets = ticket.minTickets ? ticket.minTickets : 1;
  const isManualOrder = determineManualOrder();
  if (isManualOrder) {
    ticket.maxTickets = 10;
  }
  for (var i = 1; i <= ticket.maxTickets; i++) {
    let disabled = i < minTickets;
    if (ticket.multiplesOf) {
      disabled = i % ticket.multiplesOf === 0 ? false : true;
    }
    options.push(
      <option value={i} disabled={disabled && !isManualOrder}>
        {i}
      </option>
    );
  }
  return (
    <div
      style={{
        alignItems: "center",
        display: "flex",
        flexWrap: "wrap"
      }}
    >
      <div
        style={{
          alignItems: "center",
          display: "flex"
        }}
      >
        <h5
          style={{
            margin: "0 10px 0 0",
            fontSize: 16
          }}
        >
          <label
            for={`select-tickets-${ticket._id}`}
            id={`${
              ticketGroupIndex
                ? ticketGroupIndex
                : ticket.name.replace(/\s/g, "-").toLowerCase()
            }-price`}
          >
            {ticket.price === 0
              ? "Free"
              : `$${format.checkPad(ticket.displayPrice)}`}
            {ticket.extraChargesNote ? (
              <span className={feesStr}>{ticket.extraChargesNote}</span>
            ) : null}
          </label>
        </h5>
        <div
          style={{
            width: 80
          }}
        >
          <select
            id={`select-tickets-${ticket._id}`}
            aria-labelledby={`${
              ticketGroupIndex
                ? ticketGroupIndex
                : ticket.name.replace(/\s/g, "-").toLowerCase()
            }-price ${
              ticketGroupIndex
                ? ticketGroupIndex
                : ticket.name.replace(/\s/g, "-").toLowerCase()
            }-name`}
            disabled={ticket.maxTickets ? false : true}
            class="form-select"
            onChange={evt => addQuantity(ticket._id, Number(evt.target.value))}
            value={ticket.quantity}
          >
            {options}
          </select>
        </div>
      </div>
      {ticket.quantity > 0 && isManualOrder ? (
        <div className={ticketPriceStyle}>
          <h5
            style={{
              margin: "0 10px 0 0",
              fontSize: 16,
              textAlign: "right"
            }}
          >
            <label for={`price-${ticket._id}`}>Amount Paid Per Ticket</label>
          </h5>
          <input
            style={{
              width: 80
            }}
            id={`price-${ticket._id}`}
            class="form-input"
            type="number"
            value={ticket.price}
            onChange={evt => addPrice(ticket._id, Number(evt.target.value))}
            min="0"
          />
        </div>
      ) : null}
    </div>
  );
};

const Ticket = ({
  ticket,
  addQuantity,
  addPrice,
  ticketsRemainingDisplay = false,
  eventSoldOut = false,
  ticketGroupIndex
}) => {
  const isManualOrder = determineManualOrder();
  if (isManualOrder) {
    ticket.soldOut = false;
    ticket.showWaitlist = false;
    ticket.hidden = false;
  } else {
    ticket.soldOut = eventSoldOut === true ? true : ticket.soldOut;
  }
  if (ticket.hidden && !ticket.accessGranted && !isManualOrder) {
    return null;
  }

  const ticketStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  };
  const ticketWrap = {
    borderBottom: "1px solid #d9d9d9",
    padding: "10px 0",
    animation:
      ticket.hidden && ticket.accessGranted
        ? `${accessGrantedAnimation} 5000ms 1`
        : "none"
  };
  const infoStyle = {
    flex: 1,
    paddingRight: 24
  };

  let ticketRemainingText,
    ticketRemainingTextColour = "#DD1C1C";
  if (ticket.soldOut) {
    ticketRemainingText = `Sold out`;
    ticketRemainingTextColour = "#DD1C1C";
  } else if (ticket.available && ticket.available < 10) {
    ticketRemainingText = `Only ${ticket.available} tickets left!`;
  } else if (ticket.available) {
    ticketRemainingText = `${ticket.available} tickets left`;
  }
  const descriptionStyle = {
    margin: "6px 0 0",
    fontSize: 14,
    color: "#5A626C",
    whiteSpace: "pre-line",
    wordBreak: "break-word"
  };
  return (
    <div style={ticketWrap}>
      <div style={ticketStyle}>
        <div style={infoStyle}>
          <h4
            id={
              ticketGroupIndex
                ? `${ticketGroupIndex}-name`
                : `${ticket.name}-name`
            }
            style={{
              margin: 0
            }}
          >
            {ticket.name}
          </h4>

          {ticket.includesMsg ? (
            <p
              style={descriptionStyle}
              dangerouslySetInnerHTML={{
                __html: ticket.includesMsg
              }}
            />
          ) : null}

          <p style={descriptionStyle}>{ticket.description}</p>
          {ticket.dateError ? (
            <p style={descriptionStyle}>{ticket.dateError}</p>
          ) : (
            ""
          )}
          {(ticketsRemainingDisplay || ticket.soldOut) && (
            <div
              style={{
                fontSize: 12,
                color: ticketRemainingTextColour
              }}
            >
              {ticketRemainingText}
            </div>
          )}
        </div>

        {ticket.showWaitlist ? (
          <Waitlist ticket={ticket} />
        ) : (
          <TicketsSelect
            ticket={ticket}
            addQuantity={addQuantity}
            addPrice={addPrice}
            ticketGroupIndex={ticketGroupIndex}
          />
        )}
      </div>
      <span class="text-error">
        {ticket.errors ? ticket.errors.map(err => <p>{err}</p>) : ""}
      </span>
    </div>
  );
};

export default Ticket;



// WEBPACK FOOTER //
// ./routes/tickets/components/Ticket.js